import React, { useState, useEffect } from 'react';

const Conclusao = () => {
	return <div className='text-3xl '> CONCLUSAO DE DENGEUE</div>;
};

export default Conclusao;
